"use strict";
/** @module BryxApi.ManagementApi */
Object.defineProperty(exports, "__esModule", { value: true });
var models_1 = require("../../models");
/**
 * Mixin for response option API calls.
 */
var ResponseOptionsMixin = /** @class */ (function () {
    function ResponseOptionsMixin() {
    }
    /**
     * Get response options for an agency w/ optional query
     * @param agencyId
     * @param query
     * @param types
     * @param callback
     */
    ResponseOptionsMixin.prototype.getAgencyResponseOptions = function (agencyId, query, types, callback) {
        var _this = this;
        var urlParams = {
            types: types.map(function (t) { return models_1.ResponseOptionTypeEnum[t]; }).join('+'),
        };
        if (query != null) {
            urlParams['query'] = query;
        }
        var wrappedCallback = function (request, response) {
            callback(_this.apiArrayResultFromParse(response, models_1.ResponseOption.parse, 'warn'));
        };
        this.http.get("/agencies/" + agencyId + "/response-options", urlParams, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Create a new response option in an agency
     * @param agencyId
     * @param responseOptionText
     * @param responseOptionType
     * @param callback
     */
    ResponseOptionsMixin.prototype.createResponseOption = function (agencyId, responseOptionText, responseOptionType, callback) {
        var _this = this;
        var body = {
            text: responseOptionText,
            type: models_1.ResponseOptionTypeEnum[responseOptionType],
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.ResponseOption.parse));
        };
        this.http.post("/agencies/" + agencyId + "/response-options/", null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Edit a response option by ID
     * @param agencyId
     * @param responseOptionId
     * @param responseOptionText
     * @param callback
     */
    ResponseOptionsMixin.prototype.editResponseOption = function (agencyId, responseOptionId, responseOptionText, callback) {
        var _this = this;
        var body = {
            text: responseOptionText,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.put("/agencies/" + agencyId + "/response-options/" + responseOptionId, null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Delete a response option by ID
     * @param agencyId
     * @param responseOptionId
     * @param callback
     */
    ResponseOptionsMixin.prototype.deleteResponseOption = function (agencyId, responseOptionId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.del("/agencies/" + agencyId + "/response-options/" + responseOptionId, null, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Get client memberships for a response option by ID w/ pagination
     * @param agencyId
     * @param responseOptionId
     * @param groups
     * @param limit
     * @param page
     * @param query
     * @param sortConfig
     * @param callback
     */
    ResponseOptionsMixin.prototype.getAgencyResponseOptionClientMemberships = function (agencyId, responseOptionId, groups, limit, page, query, sortConfig, callback) {
        var _this = this;
        var urlParams = {
            groups: groups.join('+'),
        };
        if (limit != null) {
            urlParams['limit'] = limit;
        }
        if (page != null) {
            urlParams['page'] = page;
        }
        if (query != null) {
            urlParams['query'] = query;
        }
        if (sortConfig != null) {
            urlParams['sortBy'] = sortConfig.column;
            urlParams['order'] = sortConfig.direction;
        }
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, function (o) { return models_1.PageResult.parse(o, 'memberships', models_1.ResponseOptionClientMembership.parse); }));
        };
        this.http.get("/agencies/" + agencyId + "/response-options/" + responseOptionId + "/memberships", urlParams, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Edit response options for a client's dispatch groups
     * @param agencyId
     * @param responseOptionId
     * @param groupIds
     * @param clientId
     * @param newValue
     * @param callback
     */
    ResponseOptionsMixin.prototype.editClientsResponseOptionForDispatchGroups = function (agencyId, responseOptionId, groupIds, clientId, newValue, callback) {
        var _this = this;
        var body = {
            clientId: clientId,
            groupIds: groupIds,
            hasOption: newValue,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.EditClientResponseOptionResult.parse));
        };
        this.http.put("/agencies/" + agencyId + "/response-options/" + responseOptionId + "/memberships", null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    return ResponseOptionsMixin;
}());
exports.default = ResponseOptionsMixin;
//# sourceMappingURL=ResponseOptionsMixin.js.map